import React from 'react';

function SimpleCoupleIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={35}
      height={44}
      viewBox="0 0 35 44"
      fill="none">
      <path
        opacity="0.4"
        d="M34.404 43.1634C34.404 43.6269 26.822 44.0006 17.4715 44.0006C8.12104 44.0006 0.539062 43.6246 0.539062 43.1634C0.539062 42.7022 8.12104 42.3262 17.4715 42.3262C26.822 42.3262 34.404 42.7022 34.404 43.1634Z"
        fill="#BCB297"
      />
      <path
        d="M31.4805 19.6716C31.4805 16.292 30.1376 14.3787 27.0404 13.8607V12.7988H23.7339V13.8607C20.6343 14.3787 19.3009 16.292 19.3009 19.6716L17.3184 29.063L19.5196 29.6117L21.6455 19.2601C21.6455 16.6372 22.678 16.8879 25.2061 16.9021V16.9352C27.8471 16.9305 29.1476 16.5805 29.1476 19.2577L31.2782 29.6094L33.4653 29.0607L31.4805 19.6692V19.6716Z"
        fill="#FFC99C"
      />
      <path
        d="M25.5918 42.0671L27.5131 41.9346L28.4209 29.2227L25.4248 29.2912C25.6365 33.0847 25.6082 40.8207 25.5918 42.0671Z"
        fill="#FFC99C"
      />
      <path
        d="M24.9336 41.9346C24.9171 40.6883 24.8489 33.0847 25.0606 29.2912L22.0645 29.2227L22.9722 41.9346H24.9336Z"
        fill="#FFC99C"
      />
      <path
        d="M30.9633 7.67144C30.9633 10.8595 28.066 13.4445 25.3733 13.4445C22.6805 13.4445 19.7832 10.8595 19.7832 7.67144C19.7832 4.4834 22.2854 1.89844 25.3733 1.89844C28.4611 1.89844 30.9633 4.4834 30.9633 7.67144Z"
        fill="#FFC99C"
      />
      <path
        d="M18.9695 30.1188C18.8402 30.6391 18.3157 30.9536 17.7983 30.8236C17.281 30.6935 16.9682 30.1661 17.0975 29.6458L17.4103 28.3923C17.5397 27.872 18.0641 27.5575 18.5815 27.6875C19.0989 27.8176 19.4116 28.345 19.2823 28.8653L18.9695 30.1188Z"
        fill="#FFC99C"
      />
      <path
        d="M31.8166 30.1188C31.9459 30.6391 32.4703 30.9536 32.9877 30.8236C33.5051 30.6935 33.8179 30.1661 33.6885 29.6458L33.3758 28.3923C33.2464 27.872 32.722 27.5575 32.2046 27.6875C31.6872 27.8176 31.3744 28.345 31.5038 28.8653L31.8166 30.1188Z"
        fill="#FFC99C"
      />
      <path
        d="M29.155 20.9254L31.8548 20.8615C31.8548 20.8615 31.622 18.7117 31.2175 17.0515C30.6201 14.6084 28.0191 14.0645 28.0191 14.0645C28.0191 14.0645 27.5864 16.3467 25.3922 16.3869C23.1981 16.3443 22.7654 14.0645 22.7654 14.0645C22.7654 14.0645 20.162 14.6108 19.567 17.0515C19.1625 18.7093 18.9297 20.8568 18.9297 20.8568L21.6295 20.9254L21.6365 24.454C19.9433 27.6657 19.0191 31.996 19.0191 31.996C19.0191 31.996 19.2048 33.3322 25.4087 33.3322C31.6126 33.3322 31.7984 31.996 31.7984 31.996C31.7984 31.996 30.8624 27.6089 29.1456 24.3877L29.1527 20.9254H29.155Z"
        fill="#89C3F1"
      />
      <path
        d="M29.155 20.9254L31.8548 20.8615C31.8548 20.8615 31.622 18.7117 31.2175 17.0515C30.6201 14.6084 28.0191 14.0645 28.0191 14.0645C28.0191 14.0645 27.5864 16.3467 25.3922 16.3869C23.1981 16.3443 22.7654 14.0645 22.7654 14.0645C22.7654 14.0645 20.162 14.6108 19.567 17.0515C19.1625 18.7093 18.9297 20.8568 18.9297 20.8568L21.6295 20.9254L21.6365 24.454C19.9433 27.6657 19.0191 31.996 19.0191 31.996C19.0191 31.996 19.2048 33.3322 25.4087 33.3322C31.6126 33.3322 31.7984 31.996 31.7984 31.996C31.7984 31.996 30.8624 27.6089 29.1456 24.3877L29.1527 20.9254H29.155Z"
        fill="#89C3F1"
      />
      <path
        d="M24.974 41.8848V43.1311H21.4628C20.9737 43.1311 21.3264 42.7858 21.8509 42.5328C22.8292 42.0621 22.9727 41.9344 22.9727 41.9344L24.974 41.8848Z"
        fill="#433934"
      />
      <path
        d="M25.5918 41.8848V43.1311H29.1547C29.6438 43.1311 29.2911 42.7858 28.7666 42.5328C27.7883 42.0621 27.619 41.9344 27.619 41.9344L25.5918 41.8848Z"
        fill="#433934"
      />
      <path
        d="M30.0699 3.58129C28.8987 2.06295 27.2831 1.57812 25.524 1.57812H25.2489C23.4898 1.57812 21.9423 1.8974 20.703 3.58129C18.9909 5.90611 19.3249 10.7095 20.2891 11.8186C21.2533 12.9278 22.0623 12.987 22.0623 12.987C20.1174 9.57661 21.6531 6.04328 21.6531 6.04328C21.6531 6.04328 23.5932 6.14734 25.3853 6.14734C27.1773 6.14734 28.5719 6.17572 29.1175 6.04328C29.1175 6.04328 30.5802 9.05158 28.7083 12.987C28.7083 12.987 29.5173 12.9255 30.4815 11.8186C31.4457 10.7118 31.8314 5.86827 30.0676 3.58129H30.0699Z"
        fill="#E09000"
      />
      <path
        d="M16.6879 7.02301C16.6879 10.211 13.7906 12.796 11.0979 12.796C8.40514 12.796 5.50781 10.211 5.50781 7.02301C5.50781 3.83496 8.01005 1.25 11.0979 1.25C14.1857 1.25 16.6879 3.83496 16.6879 7.02301Z"
        fill="#FFC99C"
      />
      <path
        d="M12.785 12.3809H9.47852V14.0435H12.785V12.3809Z"
        fill="#FFC99C"
      />
      <path
        d="M11.089 13.6274H11.0349C6.85823 13.6274 4.59587 15.7346 4.59587 19.9349L3.28125 29.4682V30.7217C3.28125 31.2869 3.7516 31.7458 4.31366 31.7458C4.87572 31.7458 5.34607 31.2869 5.34607 30.7217V30.0406H5.81171L6.47725 24.4426L6.75711 19.5423C6.75711 16.7208 8.2387 16.6073 11.042 16.6073L11.0796 16.7326C13.8852 16.7326 15.3644 16.6522 15.3644 19.4737L16.3098 30.0406H16.7073V30.7217C16.7073 31.2869 17.1776 31.7458 17.7397 31.7458C18.3017 31.7458 18.7721 31.2869 18.7721 30.7217V30.2653L18.7345 29.5297L17.2834 19.9561C17.2834 15.7559 15.2633 13.625 11.0866 13.625L11.089 13.6274Z"
        fill="#FFC99C"
      />
      <path
        d="M7.19727 25.2637L7.76168 41.8141L9.47844 41.7975L11.0071 29.1163L12.578 41.885H14.2548L14.9368 25.2637H7.19727Z"
        fill="#17385D"
      />
      <path
        d="M11.0892 15.9662C11.0892 15.9662 9.41711 13.7195 9.37243 13.7266C6.8208 14.1334 5.25455 15.725 4.7795 18.2225C4.67602 18.7617 3.33789 29.0022 3.33789 29.0022H5.99534L7.11006 20.4976L7.14299 27.2639L14.9296 27.3656L15.1248 20.6986L16.2066 29.0022H18.7699C18.7699 29.0022 17.366 18.1728 17.1331 17.4326C16.5099 15.453 15.0636 14.1097 12.853 13.7289L11.0868 15.9662H11.0892Z"
        fill="#CD232E"
      />
      <path
        d="M9.47823 41.6758V43.1303H5.57436C5.03816 43.1303 5.42385 42.7069 6.00002 42.4302C7.07241 41.9146 7.8767 41.7515 7.8767 41.7515L9.47588 41.6758H9.47823Z"
        fill="#433934"
      />
      <path
        d="M12.5781 41.7969V43.1331H16.6513C17.211 43.1331 16.8065 42.7831 16.2068 42.4946C15.0898 41.9577 14.2737 41.8323 14.2737 41.8323L12.5781 41.7969Z"
        fill="#433934"
      />
      <path
        d="M14.1557 9.65554C13.088 9.72176 12.2202 8.58182 11.1549 8.58182C10.0896 8.58182 9.21942 9.72176 8.15409 9.65554C7.0864 9.58932 6.13395 8.19633 5.51074 7.21484L5.54367 7.34019C5.54367 9.15179 6.70307 11.3158 7.98711 12.1861C9.27116 13.0588 9.95551 13.2102 11.1572 13.2102C12.359 13.2102 13.041 13.0588 14.3274 12.1861C15.6114 11.3134 16.7708 9.14943 16.7708 7.34019L16.8038 7.21484C16.1782 8.19633 15.2257 9.58932 14.1604 9.65554H14.1557ZM11.1314 10.7955C10.5105 10.7955 9.06421 9.79035 11.1314 9.79035C13.4031 9.79035 11.9568 10.7955 11.1314 10.7955Z"
        fill="#AF6617"
      />
      <path
        d="M5.50825 6.77161C5.50825 6.77161 7.75651 4.27888 8.09986 3.16969C8.09986 3.16969 13.7158 4.34746 14.9363 3.79405C14.9363 3.79405 16.4814 6.52801 16.766 7.34394C16.766 7.34394 16.9823 4.22212 15.6066 2.68722C15.6066 2.68722 16.0934 2.06286 16.0205 1.16415C16.0205 1.16415 14.3649 1.71757 13.1961 0.747909C12.0249 -0.221748 8.88769 -0.472439 7.89291 1.37227C7.89291 1.37227 4.91327 3.03488 5.50825 6.77397V6.77161Z"
        fill="#AF6617"
      />
    </svg>
  );
}

export default SimpleCoupleIcon;
